export const SET_TOKEN = (state, { token }) => {
    state.token = token
}

export const SET_CURRENT_USER = (state, { user }) => {
    state.user = user
}

export const SET_SIGNATURE = (state, { signature }) => {
    state.signature = signature
}
